import { hotRank, hotTags } from "@/mocks/home";
import SectionHead from "./SectionHead";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-primary-600",
  flat: "ri-arrow-right-line text-foreground-400",
  down: "ri-arrow-down-line text-secondary-600",
};

export default function HotZone() {
  return (
    <section id="hot" className="scroll-mt-24">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {/* hot rank */}
          <div className="lg:col-span-2">
            <SectionHead
              kicker="HOT LIST"
              title="新瓜热榜"
              sub="近 24 小时讨论热度最高的黑料与新瓜，随关注度实时更替。"
              more
              anchor="#stream"
            />
            <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
              {hotRank.map((r) => {
                const badge =
                  r.rank <= 3
                    ? "bg-primary-600 text-background-50"
                    : "bg-background-200 text-foreground-600";
                return (
                  <a
                    key={r.rank}
                    href="#stream"
                    className="group flex items-center gap-4 border-b border-background-100 px-4 py-3.5 transition-colors last:border-b-0 hover:bg-background-100 md:px-5"
                  >
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-black ${badge}`}>
                      {r.rank}
                    </span>
                    <h3 className="flex-1 truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700 md:text-base">
                      {r.title}
                    </h3>
                    <span className="hidden items-center gap-1 text-xs text-foreground-500 sm:flex">
                      <i className={trendIcon[r.trend]} />
                      {r.heat}
                    </span>
                  </a>
                );
              })}
            </div>
          </div>

          {/* hot tags + search hint */}
          <div>
            <SectionHead kicker="TRENDING WORDS" title="今日热词" />
            <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
              <p className="mb-3 text-xs leading-relaxed text-foreground-500">
                平台内被高频提及的词条，点击即可直达相关爆料流。
              </p>
              <div className="flex flex-wrap gap-2">
                {hotTags.map((t) => (
                  <a
                    key={t}
                    href="#stream"
                    className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-accent-300 hover:bg-accent-100 hover:text-accent-900"
                  >
                    <i className="ri-hashtag text-[10px]" />
                    {t}
                  </a>
                ))}
              </div>
              <div className="mt-4 flex items-center gap-2 rounded-lg bg-background-100 px-3 py-2 text-xs text-foreground-500">
                <i className="ri-lightbulb-flash-line text-accent-600" />
                找不到想要的瓜？试试在顶栏搜索关键词。
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}